/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  // Local debounce: app.js (which defines the global one) is deferred at the
  // end of <body>, so it has not run yet when this file executes.
  const localizationDebounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      // Only handle the theme's own forms; app-injected <localization-form>
      // wrappers (e.g. BLZ store selector) manage their own submission.
      if (!this.classList.contains('thb-localization-forms')) return;
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('select[name="locale_code"], select[name="country_code"]');
      this.debouncedOnSubmit = localizationDebounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}
